import {UI} from "../../../../stem-core/src/ui/UIBase";

import {PaywallPage, PaywallPageStyle} from "../../PaywallPage";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {iFrameState} from "../../../services/IFrameState";
import {GATE_TYPE, PANEL_FRAME, TNR_ALIAS, WALL_TRANSITION_TIME} from "../../../../blink-sdk/Constants";
import {isSmallScreen} from "../../../UtilsLib";
import {MerchantLogo} from "../../../common/MerchantLogo";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";

export class BasePanelPageStyle extends PaywallPageStyle {
    paddingFunction = () => iFrameState.gateType === GATE_TYPE.popup ?
        (isSmallScreen() ? "12px 18px 18px" : "18px 36px 24px") : "18px 14px";

    // TODO: This should not be in the style sheet
    shouldDisplayFrame = () => iFrameState.gateType !== GATE_TYPE.banner && iFrameState.frame === PANEL_FRAME.logo;

    @styleRuleInherit
    paywallPage = {
        border: () => "1px solid " + this.themeProps.MERCHANT_FRAME_BORDER_COLOR,
        background: this.themeProps.MERCHANT_FRAME_BACKGROUND,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        ...(this.shouldDisplayFrame() ? {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        } : {
            overflow: ["overlay", "auto"],
            padding: this.paddingFunction,
        })
    };

    @styleRule
    header = {
        width: "100%",
        background: this.themeProps.MERCHANT_FRAME_HEADER_BACKGROUND,
        padding: 12,
        borderBottom: () => "0.5px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
    };

    @styleRule
    body = {
        width: "100%",
        overflow: ["overlay", "auto"],
        flex: 1,
        padding: this.paddingFunction,
    };

    @styleRule
    button = {
        margin: "24px auto 0",
        width: "100%",
        maxWidth: isSmallScreen() ? "" : 368,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
    };

    @styleRuleInherit
    paywallPagePopup = {
        padding: 0
    };

    @styleRule
    title = this.themeProps.PAYWALL_TITLE;

    @styleRule
    secondaryButton = this.themeProps.TERTIARY_BUTTON;

    @styleRule
    link = this.themeProps.PAYWALL_LINK;

    @styleRule
    center = {
        width: "100%",
        textAlign: "center",
    };

    @styleRuleInherit
    visibilityTransition = {
        ...(this.shouldDisplayFrame() ? {
            transition: WALL_TRANSITION_TIME + "ms opacity ease",
        } : {
            transition: "",
        })
    };

    @styleRuleInherit
    visible = {
        ...(this.shouldDisplayFrame() ? {
            opacity: 1,
        } : {
            opacity: "",
        })
    };

    @styleRuleInherit
    hidden = {
        ...(this.shouldDisplayFrame() ? {
            opacity: 0,
        } : {
            opacity: "",
        })
    };

    @styleRule
    scrollFade = {
        boxShadow: "0 12px 12px 0px rgb(0 0 0 / 12%) inset, 0 -12px 12px 0px rgb(0 0 0 / 12%) inset",
    };

    @styleRule
    scrollTopFade = {
        boxShadow: "0 12px 12px 0px rgb(0 0 0 / 12%) inset",
    };

    @styleRule
    scrollBottomFade = {
        boxShadow: "0 -12px 12px 0px rgb(0 0 0 / 12%) inset",
    };

    @styleRule
    leftAlign = {
        textAlign: "left !important",
    };
}

@registerStyle(BasePanelPageStyle)
export class BasePanelPage extends PaywallPage {
    widthValue = 440;
    scrollListener = null;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: "",
        };
    }

    handleScroll() {
        try {
            this.scrollListener?.remove();
        } catch (e) {
            // Somehow magically this scroll listener gets removed.
        }
        const applyScrollStyle = element => {
            if (!element) {
                return; // Some weird redraws occurred.
            }
            element.removeClass(this.styleSheet.scrollTopFade);
            element.removeClass(this.styleSheet.scrollBottomFade);
            element.removeClass(this.styleSheet.scrollFade);
            if (element.node.scrollHeight > element.node.clientHeight) {
                if (element.node.scrollTop && element.node.scrollTop + element.node.clientHeight < element.node.scrollHeight) {
                    element.addClass(this.styleSheet.scrollFade);
                } else if (element.node.scrollTop) {
                    element.addClass(this.styleSheet.scrollTopFade);
                } else if (element.node.scrollTop + element.node.clientHeight < element.node.scrollHeight) {
                    element.addClass(this.styleSheet.scrollBottomFade);
                }
            }
        };
        if (this.styleSheet.shouldDisplayFrame() && this.body) {
            applyScrollStyle(this.body);
            this.scrollListener = this.body.addNodeListener("scroll", () => applyScrollStyle(this.body));
        } else {
            applyScrollStyle(this);
            this.scrollListener = this.addNodeListener("scroll", () => applyScrollStyle(this));
        }
    }

    getChildrenToRender() {
        this.attachTimeout(() => this.handleScroll());

        const {styleSheet} = this;
        const title = typeof this.options.title === "function" ? this.options.title() : this.options.title;
        const titleElement = title ? <div className={styleSheet.title + (iFrameMerchantService.isMerchant(TNR_ALIAS) ? styleSheet.leftAlign : "")}>{title}</div> : null;

        if (!styleSheet.shouldDisplayFrame()) {
            return [titleElement, this.render()];
        }
        return [
            <div className={styleSheet.header}>
                <MerchantLogo />
            </div>,
            <div className={styleSheet.body} ref="body">
                {titleElement}
                {this.render()}
            </div>
        ];
    }
}
